import clsx from 'clsx'

import Icon, { IconColor, IconType } from '@/components/view/atoms/icon/Icon'
import InternalLink from '@/components/view/utils/link/InternalLink'

interface Props {
  type?: IconType
  link: string
  onClick?: () => void
  disabled?: boolean
}

const BackButton = ({ type = IconType.ARROW_BACK, link, disabled = false, onClick }: Props) => {
  return (
    <div
      className={clsx(
        'z-fixed-back fixed top-18 left-64 flex h-10 w-10 min-w-10 items-center justify-center rounded-[80px]',
        disabled
          ? 'bg-surface-disabled pointer-events-none'
          : 'hover: bg-fill-primary shadow-300 hover:bg-fill-hover active:bg-fill-active active:shadow-200'
      )}
    >
      <InternalLink
        link={link}
        onClick={onClick}
        className={clsx('flex h-full w-full items-center justify-center rounded-[80px]', !disabled && 'shadow-button')}
        type='button'
      >
        <Icon type={type} color={disabled ? IconColor.DISABLED : IconColor.PRIMARY} />
      </InternalLink>
    </div>
  )
}

export default BackButton
